<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link to="/" class="d-flex align-center">
            <v-img
              :src="require(`@/assets/images/logos/logo-${$vuetify.theme.dark ? 'dark' : 'light'}.svg`)"
              max-height="auto"
              max-width="250px"
              alt="logo"
              contain
              class=""
            ></v-img>
          </router-link>
        </v-card-title>

        <v-card-text>
          <p class="text-2xl font-weight-light text--primary text-center mb-0">Alterar Senha!</p>
          <p class="text-center mb-2">Para alterar a sua senha insira uma nova e confirme.</p>
        </v-card-text>

        <v-card-text>
          <v-form>
            <v-text-field
              v-model="newPassword"
              :type="isNewPasswordVisible ? 'text' : 'password'"
              :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              label="Nova Senha"
              outlined
              dense
              hint="Certifique-se de que tenha pelo menos 8 caracteres."
              persistent-hint
              @click:append="isNewPasswordVisible = !isNewPasswordVisible"
            ></v-text-field>

            <v-text-field
              v-model="cPassword"
              :type="isCPasswordVisible ? 'text' : 'password'"
              :append-icon="isCPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              label="Confirmar Nova Senha"
              outlined
              dense
              class="mt-3"
              @click:append="isCPasswordVisible = !isCPasswordVisible"
            ></v-text-field>

            <v-btn :to="{ name: 'pages-login' }" block x-large color="primary" class="mt-6">Alterar Senha</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  setup() {
    const isNewPasswordVisible = ref(false)
    const isCPasswordVisible = ref(false)
    const newPassword = ref('87654321')
    const cPassword = ref('87654321')

    return {
      isNewPasswordVisible,
      isCPasswordVisible,
      newPassword,
      cPassword,
      icons: {
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>